import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { InvalidOperationError } from "./Error";
import { createNoDashGuid } from "./Guid";
import { Queue } from "./Queue";
export var Stream = /*#__PURE__*/function () {
  function Stream(streamId) {
    var _this = this;

    _classCallCheck(this, Stream);

    this.privIsWriteEnded = false;
    this.privIsReadEnded = false;

    this.read = function () {
      if (_this.privIsReadEnded) {
        throw new InvalidOperationError("Stream read has already finished");
      }

      return _this.privReaderQueue.dequeue().then(function (streamChunk) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(streamChunk === undefined || streamChunk.isEnd)) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return this.privReaderQueue.dispose("End of stream reached");

                case 3:
                  return _context.abrupt("return", streamChunk);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      });
    };

    this.readEnded = function () {
      if (!_this.privIsReadEnded) {
        _this.privIsReadEnded = true;
        _this.privReaderQueue = new Queue();
      }
    };

    this.throwIfClosed = function () {
      if (_this.privIsWriteEnded) {
        throw new InvalidOperationError("Stream closed");
      }
    };

    this.privId = streamId ? streamId : createNoDashGuid();
    this.privReaderQueue = new Queue();
  }

  _createClass(Stream, [{
    key: "isClosed",
    get: function get() {
      return this.privIsWriteEnded;
    }
  }, {
    key: "isReadEnded",
    get: function get() {
      return this.privIsReadEnded;
    }
  }, {
    key: "id",
    get: function get() {
      return this.privId;
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.privIsWriteEnded) {
        this.writeStreamChunk({
          buffer: null,
          isEnd: true,
          timeReceived: Date.now()
        });
        this.privIsWriteEnded = true;
      }
    }
  }, {
    key: "writeStreamChunk",
    value: function writeStreamChunk(streamChunk) {
      this.throwIfClosed();

      if (!this.privReaderQueue.isDisposed()) {
        try {
          this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {// Do nothing
        }
      }
    }
  }]);

  return Stream;
}();